import * as Yup from 'yup';

export const schema = Yup.object({
	productos_tipo: Yup.string().required(),
	productos_claveprodserv: Yup.string().min(1).max(25).required(),
	productos_descripcion: Yup.string().min(3).max(1000).required(),
	productos_numero_identificacion: Yup.string().nullable(true),
	productos_cat_units_id: Yup.string().required(),
	productos_valor: Yup.string().required(),
	productos_precio_unitario: Yup.string().required(),
	productos_cat_vat_taxes_id: Yup.mixed().required().default(1),
	productos_cat_taxobject_id: Yup.mixed().required().default(1),
	productos_cat_vat_rates_id: Yup.mixed().required().default(1),
	productos_r_isr: Yup.mixed().notRequired().nullable(true),
	productos_ieps: Yup.mixed().notRequired().nullable(true),
});
